import { _axios } from '@/plugins/axios';

const apiResource = 'api/v1/platform';

export default {
  getConfig: () => _axios.get(`${apiResource}/config`),
  setRagAnalyzerEnabled: enabled =>
    _axios.put(`${apiResource}/config/rag-analyzer?enabled=${enabled}`),
};
